import React from 'react';
import { useI18n } from 'utils/I18n/context';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';

export default function NotFoundPage() {
    const { t } = useI18n();
    const navigate = useNavigate();
    const staticNames = t?.errorPage?.notFound || {};

    const handleGoHome = () => {
        navigate(config.defaultRoute, { replace: true });
    };

    return (
        <div className="error-page text-center">
            <div className="error-page__img__wrapper">
                <img className="error-page__img" src="/frontend/en/images/404.svg?v=v1" alt="404" />
            </div>
            <h2 className="font-bold">{staticNames.title || 'Page not found'}</h2>
            <div className="error-desc">
                {staticNames.text || 'The page you are looking for does not exist.'}
                <br /><br />
                <a className="btn error-page__btn" onClick={handleGoHome} role="button" tabIndex={0} aria-label="Go to Home page">
                    {staticNames.homePageButton || 'Home page'}
                </a>
            </div>
        </div>
    );
}